module.exports = __webpack_public_path__ + "img/bu-compressed.2c9e437f.jpg";